<template>
<div @click="handleMemberClick" class="mt-6">
     <div class="w-full flex items-center justify-between md: justify-start">
       <div class="md:w-1/3">{{member.name}}</div>
       <div class="hidden md:block w-1/6">{{member.phone}}</div>
       <div class="hidden lg:block md:mr-2 lg:mr-0 w-1/3">{{member.email}}</div>
       <div class="md:hidden px-2 py-1 text-white font-bold text-10px rounded-sm" :class="member.is_captain || captainOnly ? 'green-label' : 'yellow-label'">{{member.is_captain || captainOnly ? 'к' : 'у'}}</div>
       <div class="w-1/6 hidden md:flex items-center relative">
        <p class="team-member-label" :class="member.is_captain || captainOnly ? 'green-label' : 'yellow-label'">{{member.is_captain || captainOnly ? 'Капитан' : 'Участник'}}</p>

          <!-- <on-click-outside :do="hidePopper"> -->

          <img v-if="(amICaptain && !member.is_captain) || (member.user_id == cur_user_id && !member.is_captain)" ref="button" src="@/assets/open-menu.png" alt="" class="menu-dots cursor-pointer ml-8"
           @click.prevent.stop="togglePopper">
          <!-- </on-click-outside> -->


          <div v-if="showPopper"  :class="`popper${memberIndex}`" class="popper" v-on-clickaway="hidePopper" >
            <div v-if="amICaptain && !member.is_captain">
              <p  @click.prevent.stop="appointCaptainModal = true" class="option">Назначить капитаном</p>
              <p  @click.prevent.stop="deleteMemberModal = true" class="option">Удалить участника</p>
            </div>
            <div v-else>
              <p @click="leaveTeam" class="option">Выйти из команды</p>
            </div>
        </div>
      </div>
    </div>

    <confirm-delete v-if="deleteMemberModal" key="delete_modal"  @close="deleteMemberModal = false" :reverseButtons="true"
                    @white_button="deleteMemberModal = false" @yellow_button=" deleteMember"

                    :html="` Хотите удалить участника <span class='text-brand-light break-all'>${member.name}</span> из команды <span class='text-brand-light' style='word-break: break-all'>${team.name}</span>?`"
                    :button_text_firs="'Отменить'" :button_text_second="'Удалить'"
                    class="z-100 flex absolute pin"></confirm-delete>

    <confirm-delete v-if="appointCaptainModal" key="captain-modal"  @close="appointCaptainModal = false" :reverseButtons="true"
                          @white_button="appointCaptainModal = false " @yellow_button="appointCaptain"
                          :html="`Назначить участника <span class='text-brand-light break-all'>${member.name}</span> капитаном команды <span class='text-brand-light' style='word-break: break-all' >${team.name}</span>?`"
                          :button_text_firs=" 'Отменить'" :button_text_second="'Назначить' "
                          class="z-100 flex absolute pin"></confirm-delete>
    <reg-modal v-if="deletedModal" @close="deletedModal = false; $emit('memberDeleted')">
            <p class="text-sm text-center font-bold ">
                Участник <span class="text-brand-light"> {{member.name}} </span> удален из команды
            </p>
             <p class="text-sm mt-8 mb-3 text-center mt-10">
                Вы можете вернуть участника в команду,<br> отправив ему приглашение из Личного<br> кабинета
            </p>
   </reg-modal>
    <reg-modal  v-if="newCapModal" @close="newCapModal = false; $emit('updateMembers')">
            <p class="text-sm text-center font-bold line-height-17" style="width:400px">
                <span class="text-brand-light "> {{member.name}} </span>назначен капитаном команды
                <span class="text-brand-light " style='word-break: break-all'> {{team.name}}</span>
            </p>
             <p class="text-sm mt-8 mb-3 text-center mt-10" style="width:400px">
              <span>Ваш статус в команде</span><span class="text-brand-light" style='word-break:break-all'> {{team.name}}</span>
               изменен на  <span class="text-brand-light"> Участник </span>
            </p>
   </reg-modal>
</div>
</template>
<script>
import OnClickOutside from '@/views/OnClickOutside';
import ConfirmDelete from '@/views/partners/events/order/delete-modal.vue';
import regModal from '@/views/partners/current-registration/registration-layout/registration-modal.vue';
import players from '@/clients/player.js';
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'team-member',
  mixins: [clickaway],
  components: { OnClickOutside, ConfirmDelete, regModal },
  data() {
    return {
      showPopper: false,
      deleteMemberModal: false,
      appointCaptainModal: false,
      deletedModal: false,
      newCapModal: false,

    };
  },
  props: ['member', 'amICaptain', 'team', 'captainOnly', 'memberIndex'],
  computed: {
    ...mapState({
      cur_user_id: state => state.auth.user.id,
    }),
  },
  methods: {
    ...mapActions(['refreshUser']),
    handleMemberClick() {
      if (window.innerWidth > 840) {
        this.hidePopper();
      } else {
        this.$router.push({
          name: 'teamMemberInfo',
          params: {
            memberId: this.member.user_id,
            member: this.member,
            team: this.team,
            amICaptain: this.amICaptain,
          },
        });
      }
    },
    hidePopper() {
      this.showPopper = false;
    },
    togglePopper() {
      const x = document.getElementsByClassName('popper');
      for (let index = 0; index < x.length; index++) {
        if (x[index].classList[1] == `popper${this.memberIndex}`) {
          x[index].hidden = false;
        } else {
          x[index].hidden = true;
        }
      }
      this.showPopper = !this.showPopper;
    },
    deleteMember() {
      players.delete(`/teams/${this.team.id}/players`, { params: { user_id: this.member.user_id } }).then((resp) => {
        this.deleteMemberModal = false;
        this.deletedModal = true;
      });
    },
    appointCaptain() {
      players.patch(`/teams/${this.team.id}/captain`, {
        user_id: this.member.user_id,
      }).then((resp) => {
        this.appointCaptainModal = false;
        this.newCapModal = true;
      });
    },
    leaveTeam() {
      this.$emit('leave');
    },
    updateUser() {
      this.refreshUser(players);
    },
  },
};
</script>
<style scoped>
.option {
    width: 288px;
    @apply pl-5 py-2;
    background-color: white;
    cursor: pointer;
}
.option:hover {
    @apply bg-brand-light text-white
}
.popper {
    position: absolute;
    top: 35px;
    right: 35%;
    border: 1px solid #DADADA;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 5;
}
.team-member-label-mobile {

  border-radius: 3px;
}
.line-height-17{
  line-height: 17px;
}
</style>
